module.exports = __webpack_public_path__ + "static/assets/3d1e17b45de190f195ed2f0150b0123d.gif";